<template>
    <div class="os-tabs-w">
        <div class="os-tabs-controls">
            <ul class="nav nav-tabs upper">
                <li v-for="(v, k) in programs" :key="k" class="nav-item">
                    <router-link :to="'/'+k" :class="['nav-link', { 'active': program === k }]"> {{ k }}</router-link>
                </li>
            </ul>
            <div v-if="registrationAllowed" class="register-button">
                <router-link :to="'/'+program+'/register'" class="btn btn-outline-primary btn-rounded">
                    <i class="os-icon os-icon-ui-22"></i><span>Create New {{ peer.common.programName() }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { programs } from '@/data'

export default {
    data() {
        return {
            programs: programs,
            serverTime: null
        }
    },
    
    computed: {
        program() {
            return this.peer.common.programName('r')
        },
        
        registrationAllowed() {
            return this.peer.project.isRegistrationAllowed(this.program, this.serverTime)
        }
    },
    
    async mounted() {
        this.serverTime = await this.peer.common.serverTime()
        this.serverTime = parseInt((this.serverTime / 1000).toFixed(0))
    }
}
</script>
